var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeligram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6657 0.195535C32.5276 -0.160298 33.5143 -0.0240747 34.2475 0.551965C34.9807 1.12801 35.3466 2.05446 35.2048 2.97605C34.2013 9.50237 32.3615 21.4614 31.3848 27.8095C31.2474 28.7029 30.6529 29.4595 29.8174 29.8045C28.9819 30.1494 28.0268 30.0326 27.2991 29.4964C23.8442 26.951 18.6643 23.1345 16.0344 21.1962C15.6235 20.8934 15.3681 20.424 15.3371 19.9146C15.306 19.4052 15.5025 18.9082 15.8735 18.5578C18.2833 16.2819 23.083 11.749 26.3852 8.63007C26.5464 8.47686 26.5644 8.22611 26.4268 8.05146C26.2891 7.87681 26.0411 7.83573 25.8544 7.95668C21.6203 10.7182 15.1357 14.9471 11.9575 17.0198C10.7534 17.8051 9.2766 18.0532 7.88205 17.7044C6.13202 17.267 3.60777 16.6358 1.36141 16.0743C0.640034 15.8941 0.115786 15.2712 0.0613003 14.5297C0.00681421 13.7881 0.434393 13.0953 1.12168 12.8116C8.94155 9.58159 24.245 3.26107 31.6657 0.195535Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeligram);
export default __webpack_public_path__ + "static/media/teligram.e9e853a22fea7988361a2907e44e3e07.svg";
export { ForwardRef as ReactComponent };